import { render } from "react-dom";
import React from "react";
import styles from "./styles.scss";

export function PlusIcon() {
  return (
    <svg
      className={styles.plus}
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 34 34"
      style={{ enableBackground: "new 0 0 34 34" }}
    >
      <g>
        <line
          className={styles.line}
          x1="17.5"
          y1="34"
          x2="17.5"
          y2="0"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <g>
        <line
          className={styles.line}
          x1="34"
          y1="17"
          x2="0"
          y2="17"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </svg>
  );
}
